import type { Item } from '@shared/types-v0.1.0'
import { findObjectsWithValidId } from './utils'

export type GetItems = typeof getItems

/**
 * Находит в переданных данных все ID объектов и возвращает соответствующие объекты из R.items.
 * Если указана таблица, фильтрует только объекты с этой таблицей.
 * @param data - объект данных для поиска
 * @param table - название таблицы (опционально)
 * @returns массив айтемов из R.items без дубликатов
 */
export const getItems = (data: any, table?: string): Item[] => {
	if (!data) {
		return []
	}

	// Находим объекты с валидными ID
	const rawItems = findObjectsWithValidId(data)

	// Фильтруем только те, у которых таблица совпадает с искомой (если таблица указана)
	const filteredIds = table
		? rawItems.filter((item) => item.id && item.id.tb === table).map((item) => item.id.id)
		: rawItems.map((item) => item.id.id)

	// Удаляем дубликаты id
	const uniqueIds = [...new Set(filteredIds)]

	// Собираем соответствующие айтемы из R.items
	const items: Item[] = []
	for (const id of uniqueIds) {
		const item = R.items[id]
		if (item) {
			items.push(item)
		}
	}

	return items
}
